import { useMemo, useState } from "react";
import { buildSegmentBreakdown } from "../lib/growthAnalyticsMetrics";

const RANGES = [
  { id: "all", label: "All time" },
  { id: "30d", label: "30 days" },
  { id: "month", label: "This month" },
  { id: "7d", label: "7 days" },
];

export default function SegmentCard({
  title,
  contacts,
  labelFn,
  getTimestampMs,
  onDrill,
  drillKey,
  excludeInternal = true,
}) {
  const [range, setRange] = useState("all");
  const [topN, setTopN] = useState(6);
  const [hideUnset, setHideUnset] = useState(true);

  const rows = useMemo(() => {
    const now = Date.now();
    const msDay = 86400000;
    const monthStart = new Date(new Date().getFullYear(), new Date().getMonth(), 1).getTime();
    const pool = contacts.filter((c) => {
      if (excludeInternal && c.isInternal) return false;
      const t = getTimestampMs?.(c);
      if (!t) return range === "all";
      if (range === "7d") return t >= now - 7 * msDay;
      if (range === "30d") return t >= now - 30 * msDay;
      if (range === "month") return t >= monthStart;
      return true;
    });
    let list = buildSegmentBreakdown(pool, labelFn, { maxRows: topN + 3 });
    if (hideUnset) list = list.filter((r) => r.label !== "Not set");
    return list.slice(0, topN);
  }, [contacts, labelFn, getTimestampMs, range, topN, hideUnset, excludeInternal]);

  const max = Math.max(1, ...rows.map((r) => r.count));

  return (
    <div className="card segment-card">
      <div className="section-header" style={{ marginBottom: 8 }}>
        <div className="section-title" style={{ fontSize: 13 }}>{title}</div>
        {onDrill && drillKey && (
          <button type="button" className="btn btn-sm btn-ghost" onClick={() => onDrill(drillKey, title)}>
            All users
          </button>
        )}
      </div>
      <div className="segment-card-filters">
        {RANGES.map((r) => (
          <button
            key={r.id}
            type="button"
            className={`filter-chip ${range === r.id ? "active" : ""}`}
            onClick={() => setRange(r.id)}
          >
            {r.label}
          </button>
        ))}
        <select className="input segment-card-topn" value={topN} onChange={(e) => setTopN(Number(e.target.value))}>
          {[4, 6, 8, 12].map((n) => (
            <option key={n} value={n}>Top {n}</option>
          ))}
        </select>
        <label className="segment-card-hide-unset">
          <input type="checkbox" checked={hideUnset} onChange={(e) => setHideUnset(e.target.checked)} />
          Hide &quot;Not set&quot;
        </label>
      </div>
      <div className="segment-card-rows">
        {rows.length === 0 ? (
          <p className="text-caption">No data in range.</p>
        ) : (
          rows.map((row) => (
            <div key={row.label} className="segment-card-row">
              <div className="segment-card-row-labels">
                <span>{row.label}</span>
                <span>{row.count} ({row.pct.toFixed(0)}%)</span>
              </div>
              <div className="funnel-stage-track">
                <div className="funnel-stage-fill" style={{ width: `${(row.count / max) * 100}%` }} />
              </div>
            </div>
          ))
        )}
      </div>
    </div>
  );
}
